@import "../../global/normalize.css";

:host {
  --indicator-initial-color: rgba(23 89 188 / 0%);
  --focus-indicator: var(--ic-border-focus);

  display: flex;
  align-items: center;
  border-radius: 0;
  color: var(--ic-tab-label);

  --ic-typography-color: var(--ic-tab-label);

  height: 2.5rem;
  padding: 0 var(--ic-space-md);
  cursor: pointer;
  position: relative;
  border-bottom: var(--ic-space-xxs) solid var(--indicator-initial-color);
  gap: var(--ic-space-xs);
  transition: all var(--ic-easing-transition-fast);
}

::slotted([slot="icon"]) {
  fill: var(--ic-tab-icon);
}

:host(.ic-tab-disabled) ::slotted([slot="icon"]) {
  fill: var(--ic-tab-icon-disabled);
}

:host(:focus) {
  box-shadow: var(--focus-indicator);
  border-radius: var(--ic-border-radius);
}

:host(:focus-visible) {
  outline: var(--ic-hc-focus-outline);
}

:host(:hover) {
  background-color: var(--ic-tab-item-hover);
}

:host(:active) {
  background-color: var(--ic-tab-item-pressed);
}

:host(.ic-tab-selected) {
  border-bottom: var(--ic-space-xxs) solid var(--ic-tab-item);
}

:host(.ic-tab-disabled) {
  pointer-events: none;
  color: var(--ic-architectural-300);
}

:host(.ic-tab-disabled) ic-typography {
  --ic-typography-color: var(--ic-tab-label-disabled);
}

:host(.ic-tab-monochrome) {
  color: var(--ic-tab-label-monochrome);
}

:host(.ic-tab-monochrome.ic-tab-disabled) ic-typography {
  color: var(--ic-tab-label-monochrome-disabled);
}

:host(.ic-tab-monochrome) ::slotted([slot="icon"]) {
  fill: var(--ic-tab-icon-monochrome);
}

:host(.ic-tab-monochrome.ic-tab-disabled) ::slotted([slot="icon"]) {
  fill: var(--ic-tab-icon-monochrome-disabled);
}

:host(.ic-tab-monochrome.ic-tab-selected) {
  border-bottom: var(--ic-space-xxs) solid var(--ic-tab-item-monochrome);
}

:host(.ic-tab-monochrome:hover) {
  background-color: var(--ic-tab-item-hover-monochrome);
}

:host(.ic-tab-monochrome:active) {
  background-color: var(--ic-tab-item-pressed-monochrome);
}

@media (prefers-reduced-motion: no-preference) {
  :host(.ic-tab-selected.with-transition) {
    transition: all var(--ic-easing-transition-slow),
      border-color var(--ic-transition-duration-slow);
  }
}

.ic-tab-label {
  pointer-events: none;
  text-wrap: nowrap;
}

::slotted(svg) {
  fill: currentcolor;
}

@media (forced-colors: active) {
  :host {
    border-bottom: var(--ic-space-xxs) solid canvas;
  }

  :host(.ic-tab-disabled) {
    color: GrayText;
  }

  :host(.ic-tab-disabled) ic-typography {
    color: GrayText;

    --ic-typography-color: GrayText;
  }
}

/* Add back in after storybook has the `color-scheme: light dark` code */

/* @media (prefers-color-scheme: dark) and (not (forced-colors: active)) {
  :host(ic-tab) .ic-tab-label {
    color: var(--ic-architectural-white);
  }
  :host(ic-tab.ic-tab-disabled) .ic-tab-label {
    color: inherit;
  }
} */

@media (prefers-reduced-motion: reduce) {
  :host {
    transition: none;
  }
}
